import i18next from 'i18next';
import { ApolloLink, Observable } from '@apollo/client';

/** Opt-in deadline for report queries. Unsubscribing also cancels their HTTP request. */
export const reportTimeoutLink = new ApolloLink((operation, forward) => {
  const timeoutMs = operation.getContext().reportTimeoutMs;
  if (!Number.isFinite(timeoutMs) || timeoutMs <= 0) return forward(operation);
  return new Observable((observer) => {
    const timer = setTimeout(() => {
      const message = 'The report took too long to respond. Please try again.';
      observer.error(
        new Error(i18next.t(message, { defaultValue: message }) || message)
      );
    }, timeoutMs);
    const subscription = forward(operation).subscribe({
      next: (result) => observer.next(result),
      error: (error) => {
        clearTimeout(timer);
        observer.error(error);
      },
      complete: () => {
        clearTimeout(timer);
        observer.complete();
      }
    });
    return () => {
      clearTimeout(timer);
      subscription.unsubscribe();
    };
  });
});

export const REPORT_REQUEST_CONTEXT = Object.freeze({ reportTimeoutMs: 45000 });
